import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/BlogDouble/Banner'
import BlogDetailSection from '../Component/BlogDouble/BlogDetailSection'
import Footer from '../Component/NavBarFooter/Footer'

function BlogDouble() {
  return (
    <div>
        <NavBar/>
        <Banner/>
        <BlogDetailSection/>
        <Footer/>

    </div>
  )
}

export default BlogDouble